module.exports = __webpack_public_path__ + "files/cc332894c1db8fbd2c1ed921e007f441.png";